import "./RoadmapCard.css";

const RoadmapCard = ({ product, color }) => {
  return (
    <div className="roadmap-card">

      <h3>{product.name}</h3>

      {product.eta && (
        <div
          className="roadmap-eta"
          style={{ background: color }}
        >
          {product.eta}
        </div>
      )}

      {product.features && (
        <ul>
          {product.features.map((feature) => (
            <li key={feature}>
              <i className="bi bi-check-square"></i> {feature}
            </li>
          ))}
        </ul>
      )}

    </div>
  );
};

export default RoadmapCard;